const event = new Event('formNumberControlUpdate');
const changeEvent = new Event('change');

class NumberControl {
    constructor(el) {
        this.el = el;
        this.inputField = el.querySelector('input');
        this.value = 0;
        this.minButton = el.querySelector('.decrease-btn');
        this.maxButton = el.querySelector('.increase-btn');
        this.min = parseInt(this.inputField.dataset.min);
        this.max = parseInt(this.inputField.dataset.max);
        // is there an increment setting?
        this.incrementBy = 1; //default
        let inc = this.inputField.dataset.increment;
        if (typeof (inc) != 'undefined') {
            this.incrementBy = parseInt(inc);
        }
        // is there a range slider to tether to this control?
        this.hasSlider = false;
        let slider = this.inputField.dataset.sliderId;
        if (typeof (slider) != 'undefined') {
            this.slider = document.getElementById(slider);
            if (this.slider != null) this.hasSlider = true;
        }
        // validate number
        this.validateNumber();
        // behaviours
        this.minButton.onclick = (e) => {
            e.preventDefault();
            this.increment(false);
        };
        this.maxButton.onclick = (e) => {
            e.preventDefault();
            this.increment(true);
        };
        this.inputField.onblur = () => {
            this.validateNumber(false);
        };
        this.inputField.addEventListener('valueChange', (e) => {
            this.inputField.value = e.detail.Quantity;
            this.value = e.detail.Quantity;
        }, false);
        // slider behaviours
        if (this.hasSlider) {
            this.slider.addEventListener('input', () => {
                this.valueFromSlider();
            });
            this.slider.addEventListener('change', () => {
                this.valueFromSlider();
            });
        }
        // disabled return key on input field
        this.inputField.addEventListener('keydown', (e) => {
            switch (e.key) {
                case 'Enter':
                case 'Return':
                    e.preventDefault();
                    break;
            }
        });
    }
    increment(mode) {
        if (mode && this.value < this.max) {
            this.value += this.incrementBy;
        } else if (!mode && this.value > this.min) {
            this.value -= this.incrementBy;
        }
        this.inputField.value = this.value;
        this.inputField.dispatchEvent(event);
        this.inputField.dispatchEvent(changeEvent);
        this.checkButtons();
        // update slider ?
        if (this.hasSlider) this.valueToSlider();
    }
    checkButtons() {
        if (this.value <= this.min) {
            this.minButton.setAttribute('disabled', 'disabled');
        } else {
            this.minButton.removeAttribute('disabled');
        }
        if (this.value >= this.max) {
            this.maxButton.setAttribute('disabled', 'disabled');
        } else {
            this.maxButton.removeAttribute('disabled');
        }
    }
    validateNumber() {
        this.value = parseInt(this.inputField.value);
        if (isNaN(this.value)) this.value = 0;
        // check value is a multiple of the incrementBy amount
        this.value = this.incrementBy * Math.round(this.value / this.incrementBy);
        // apply limits
        if (this.value < this.min) this.value = this.min;
        if (this.value > this.max) this.value = this.max;
        // update
        this.inputField.value = this.value;
        this.inputField.dispatchEvent(event);
        this.inputField.dispatchEvent(changeEvent);
        this.checkButtons();
        // update slider ?
        if (this.hasSlider) this.valueToSlider();
    }
    valueFromSlider() {
        let sliderValue = this.slider.value;
        if (sliderValue !== this.value) {
            this.inputField.value = this.slider.value;
            this.validateNumber();
        }
    }
    valueToSlider() {
        let sliderValue = parseInt(this.slider.value);
        if (sliderValue !== this.value) this.slider.value = this.value;
    }
}

export function createFrom(wrappers) {
    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new NumberControl(node);
        }
    });
}
